export class BaseTransition {

    getDisplayName() {
        throw new Error('Missing implementation for display name');
    }

    getVertexShader(item) {
        return null;
    }

    getFragmentShader(item) {
        return null;
    }

    shouldWaitForTransitionEnd() {
        return true;
    }

    getUniformBaseData(item) {
        throw new Error('Missing implementation for uniform base data');
    }

    getUniformStartData(item) {
        throw new Error('Missing implementation for uniform start data');
    }

    getUniformEndData(item) {
        throw new Error('Missing implementation for uniform end data');
    }
}
